import React, { useState } from "react";
import { Box, Grid, TextField, Button, Typography, Paper } from "@mui/material";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

const ContactUsForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_vqj3a6r",
        "template_dm6ondm",
        formData,
        "GCSFS2aW29TYPqH2p"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);

          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Email Sent Successfully!",
            confirmButtonColor: "#4A602F",
          });

          setFormData({
            name: "",
            email: "",
            mobile: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          console.log("FAILED...", error);

          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Email Sending Failed!",
            confirmButtonColor: "#d33",
          });
        }
      );
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "300px",
          backgroundImage: "url('https://cdn.pixabay.com/photo/2017/06/19/05/36/contact-us-2418235_1280.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#fff",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(0, 0, 0, 0.5)", 
          },
        }}
      >
     
      </Box>
      <Box sx={{ padding: "40px 20px", backgroundColor: "#f5f5f5" }}>
        <Typography
          variant="h4"
          align="center"
          sx={{ marginBottom: "40px", fontSize: "25px", fontWeight: "700" }}
        >
          Contact Us
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {/* Contact Information Section (Left Side) */}
          <Grid item xs={12} sm={6} md={6} sx={{ textAlign: "center" }}>
            <Paper elevation={3} sx={{ padding: "20px", borderRadius: 2 }}>
              <Typography variant="h6" sx={{ marginBottom: "20px" }}>
                Contact Information
              </Typography>
              <Typography variant="body1">
                <strong>West Valley Organic Farm</strong>
              </Typography>
              <Typography variant="body2">
                89 Parvati Complex, LBD Road,
              </Typography>
              <Typography variant="body2">Pune - 411030</Typography>
              <Typography variant="body2">
                Email Id:{" "}
                <a href="mailto:westvalleyorganicfarm@gmail.com">
                  westvalleyorganicfarm@gmail.com
                </a>
              </Typography>
              <Typography variant="body2">
                Website:{" "}
                <a
                  href="https://www.westvalleyorganicfarm.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.westvalleyorganicfarm.com
                </a>
              </Typography>
            </Paper>
          </Grid>

          {/* Contact Us Form Section (Right Side) */}
          <Grid item xs={12} sm={6} md={6}>
            <Paper elevation={3} sx={{ padding: "20px", borderRadius: 2 }}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  {/* Name Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      name="name"
                      variant="outlined"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Email Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      name="email"
                      variant="outlined"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Mobile Number Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      name="mobile"
                      variant="outlined"
                      type="tel"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Subject Field */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Subject"
                      name="subject"
                      variant="outlined"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Message Field */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      name="message"
                      variant="outlined"
                      multiline
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Submit Button */}
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      sx={{ padding: "10px", background: "#4A602F" }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ContactUsForm;
